module.exports = __webpack_public_path__ + "static/media/skoterval.35886109.jpg";